<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ded">
<p class="ct"><a class="xref" href="#/pppclubbeddeath005#toc">Dedication</a></p>
<p class="ded"><i>To James and John—the most direct inspirations for this book</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppclubbeddeath004.vue?0b4de48b